import { CSSProperties, ReactNode } from "react";
import { IObject, IResponse } from "../constants/interface";
import { TransferDirection } from "antd/lib/transfer";
import { ColumnsType } from "antd/lib/table";
import { TableRowSelection } from "antd/lib/table/interface";
import { FormInstance } from "antd/lib/form";
import { TransferKey } from "antd/lib/transfer/interface";

export interface SuperTransferProps extends TransferBaseProps {
  /** 值 */
  value?: any[];
  /** 额外参数 */
  otherParams?: IObject;
  /** 下拉选项的值对应data的那个字段 */
  dataKey?: string | false;
  /** 标题对应字段名称 */
  labelKey?: string;
  /** 缓存标记 不传则不开启缓存 */
  transferKey?: string;
  /** 点击按钮文字 */
  buttonText?: ReactNode;
  /** 弹窗文字 */
  modalTitle?: ReactNode;
  /** 排序字段名称 */
  sortFieldname?: string;
  /** 是否必选 */
  required?: boolean;
  /** 其他需要提取出来的有效字段名称或集合 */
  otherExtractFieldnames?: string | string[];
  /** 是否禁用 */
  disabled?: boolean;
  /** 接口、参数改变是否清空当前选中值 */
  changeEmptyValue?: boolean;
  /** 接口API */
  fetchApi?: (params: any) => Promise<IResponse>;
  /** 获取数据之前回调 */
  beforeFetch?: (params: any, record?: any) => any;
  /** 过滤接口返回数据 */
  filterData?: (data: any[]) => any[];
  /** 值改变回调 */
  onChange?: (selectedDataSource?: any[], form?: FormInstance<any>, index?: number) => void;
};
interface TransferBaseProps {
  /** 单个穿梭器宽度 */
  listWidth?: number;
  /** 穿梭器高度 */
  listHeight?: number;
  /** 是否开启拖动排序 */
  isMoveSort?: boolean;
  /** 选中数据 */
  selectedDataSource?: any[];
  /** 行标识 */
  rowKey?: string;
  /** 列配置 */
  columns?: ColumnsType<any>;
  /** 搜索字段集合*/
  searchFieldnames?: string | string[];
}
export interface TableTransferProps extends TransferBaseProps {
  /** 数据源 */
  dataSource?: any[];
  /** 选中数据改变 */
  onChange: (targetKeys: TransferKey[], direction: TransferDirection, moveKeys: TransferKey[]) => void;
  /** 排序回调 */
  onDragEnd: (startKey: string, endKey: string) => void;
};
export interface LeftTableProps {
  /** 数据源 */
  dataSource?: any[];
  /** 列配置 */
  columns?: ColumnsType<any>;
  /** 行标识 */
  rowKey?: string;
  /** 宽度 */
  width?: number;
  /** 高度 */
  height?: number;
  /** 选择框配置 */
  rowSelection?: TableRowSelection<any>;
  /** 设置行属性 */
  onRow?: (record: any, index?: number) => any;
};
export interface RightTableProps {
  /** 数据源 */
  dataSource?: any[];
  /** 列配置 */
  columns?: ColumnsType<any>;
  /** 行标识 */
  rowKey?: string;
  /** 宽度 */
  width?: number;
  /** 高度 */
  height?: number;
  /** 选中数据 */
  selectedDataSource?: any[];
  /** 是否开启拖动排序 */
  isMoveSort?: boolean;
  /** 删除 */
  onDelete: (key: string) => void;
  /** 排序回调 */
  onDragEnd: (startKey: string, endKey: string) => void;
};
export interface MoveTransferTableRowProps {
  /** 样式 */
  style?: CSSProperties;
  /** 单元格数据集合 */
  children?: any[];
  /** 第几行 */
  index?: number;
  /** 行标识 */
  'data-row-key'?: any;
};

/** 默认行标识 */
export const DEFAULT_ROW_KEY: string = 'key';
/** 默认标题字段 */
export const DEFAULT_LABEL_KEY: string = 'label';
/** 排序列字段名 */
export const SORT_DATAINDEX: string = 'transfer-sort-key';
/** 排序字段名 */
export const SORT_FIELDNAME: string = 'displayOrder';
